export class WalletAggregator {
    constructor(providers) {
        this.walletProviders = providers;
    }
    getWallets() {
        let wallets = [];
        for (let provider of this.walletProviders) {
            wallets.push(...provider.getWallets());
        }
        return wallets;
    }
}
//# sourceMappingURL=walletAggregator.js.map